import { DialogTitle } from '@mui/material'
import { styled } from 'styled-components'

export const StyledDialogTitle = styled(DialogTitle)`
  min-width: 400px;
`
